import { takeLatest } from 'redux-saga/effects'
import { FIND_ARCHIVE_SAGA } from 'src/store/types/archiveData'
import fetchArchive from './fetchArchive'

export function* findArchiveSaga() {
  yield takeLatest(FIND_ARCHIVE_SAGA, fetchArchive)
}
